import { Flex, Form, Input } from 'antd';
import Checkbox from 'antd/es/checkbox';
import { FormInstance, RuleObject, RuleRender } from 'antd/es/form';
import { FormInstance as RcFormInstance } from 'rc-field-form';
import { useMemo } from 'react';
import { FormConfigProps } from '../constants/constants';

export const OTHER_TOGGLE = 'other_toggle';

const getRequiredIfToggledRule =
  (toggleFieldName: string[]): RuleRender =>
  (form: RcFormInstance): RuleObject => {
    return {
      validator: (_, value?: string) => {
        const isEnabled = form.getFieldValue(toggleFieldName);
        const valueIsEmpty = !value || value.length <= 0;
        const result =
          isEnabled && valueIsEmpty
            ? Promise.reject('Įvedimas privalomas pažymėjus laukelį!')
            : Promise.resolve();
        return result;
      },
    };
  };

type OtherInputItemProps = {
  form: FormInstance;
  item: FormConfigProps;
  statePathParams: string[];
};

export const OtherInputItem = ({
  form,
  item,
  statePathParams,
}: OtherInputItemProps) => {
  const [toggleFieldName, requiredIfToggledRule] = useMemo(() => {
    const toggleFieldName = statePathParams
      .slice(0, statePathParams.length - 1)
      .concat([OTHER_TOGGLE]);

    return [toggleFieldName, getRequiredIfToggledRule(toggleFieldName)];
  }, [statePathParams]);

  const toggleValue = Form.useWatch(toggleFieldName, form);

  return (
    <Flex
      justify="center"
      gap={8}
      style={{
        paddingLeft: item.paddingLeft,
        marginBottom: 4,
      }}
    >
      <Form.Item name={toggleFieldName} valuePropName="checked">
        <Checkbox
          onChange={(checkbox) => {
            if (!checkbox.target.checked) {
              form.setFieldValue(statePathParams, '');
              form.validateFields([statePathParams]);
            }
          }}
        />
      </Form.Item>
      <Form.Item
        key={item.value}
        name={statePathParams}
        style={{ marginBottom: 0, width: '100%' }}
        rules={[requiredIfToggledRule]}
      >
        <Input placeholder={item.label} allowClear disabled={!toggleValue} />
      </Form.Item>
    </Flex>
  );
};
